<template>
  <div class="row">
      <div class="col-sm-5 m-auto">
          <div class="text-center mb-4">
            <h1>Log In</h1>
          </div> 
          <form id="login-form" @submit.prevent="login">
              <div class="row">
                  <div class="col-sm-12 form-group">
                      <label for="email">Email address</label>
                      <input type="email" id="email" v-model="email" class="form-control form-control-lg">
                  </div>
                  <div class="col-sm-12 form-group">
                      <label for="Password">Password</label>
                      <input type="Password" id="Password" v-model="password" class="form-control form-control-lg">
                      <p class="text-danger" v-if="this.validation_message.length > 0"> {{ validation_message }}</p>
                  </div>
                  <div class="col-sm-12 form-group text-center" :class="{'mt-4': this.validation_message.length == 0}">
                      <button v-if="!xhrRequest" class="btn btn-primary btn-lg col-sm-4">Login</button>
                      <button v-if="xhrRequest" class="btn btn-primary btn-lg col-sm-4" :disabled=true>
                          <span class="spinner-border spinner-border-sm"></span>
                          wait...
                      </button>
                  </div>
              </div>
          </form>
      </div>
  </div>
</template>

<script>
import firebase from 'firebase';

export default {
    data() {
        return {
            email: '',
            password: '',
            xhrRequest: false,
            status: 'not_accepted',
            validation_message: ''
        }
    },
    methods: {
        login() {
            let v = this;

            v.xhrRequest = true;
            var database = firebase.firestore();
            var usersRef = database.collection("users");
            var self = this;

            firebase.auth().signInWithEmailAndPassword(this.email, this.password).then(() => {
                var userId = firebase.auth().currentUser.uid;
                var docRef = usersRef.doc(userId);
                docRef.get().then((doc) => {
                    if (doc) {
                        console.log(doc.data());
                        this.$emit('updateUserInfo', doc.data());
                        this.$emit('authentication', true);
                    } else {
                        console.log("No such document!");
                    }
                }).catch((error) => {
                    console.log("Error getting document", error);
                });
            },
            (err) => {
                v.xhrRequest = false;
                console.log(`Error - ${err.message}`);
                self.validation_message = 'Username/password is incorrect';
            })
        }
    }
}
</script>

<style>
</style>>